import { newApiUrl, baseApiUrl } from '../../config/env';
import AsyncStoreService from '../async-store.service';

const getToken = async () => {
  const token = await AsyncStoreService.getTokenData();
  if (!token) {
    return { error: 'User is not logged' };
  }
  return token;
};

export const flightStatusApi = async (departureDateTime, flightNumber, airlineCode) => {
  const params = {
    departureDateTime,
    flightNumber,
    airlineCode,
  };

  const res = await fetch(`${newApiUrl}/Flifo_sabreapi`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  });

  const resultJson = await res.json();

  if (resultJson.Error) {
    throw new Error(resultJson.Error?.Message);
  }

  return resultJson;
};

export const setDutyOfCareApi = async (params) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/Trip/DutyOfCare`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
    body: JSON.stringify(params),
  });

  const resultJson = await res.json();

  console.log('duty of care ', resultJson);
  return resultJson;
};

export const getDutyOfCareByTripKeyApi = async (tripKey) => {
  const token = await getToken();
  const res = await fetch(
    `${baseApiUrl}/Trip/GetDutyOfCare${tripKey ? `?tripKey=${tripKey}` : ''}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token?.access_token}`,
      },
    }
  );
  // convert response to local time
  const resultJson = await res.json();

  return resultJson;
};

export const getVirtualCardInfoApi = async (tripKey, sourceType, sourceIdentifier) => {
  try {
    const token = await getToken();
    const params = {
      trackingInfo: { TripRequestId: tripKey },
      SourceType: sourceType,
      SourceIdentifier: sourceIdentifier,
    };
    const res = await fetch(`${baseApiUrl}/Trip/GetVirtualCardInfo`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token?.access_token}`,
      },
      body: JSON.stringify(params),
    });
    if (!res) {
      return null;
    }
    const resultJson = await res.json();
    return resultJson;
  } catch (error) {
    throw new Error('getVirtualCardInfoApi failed');
  }
};

export const addHotelReviewApi = async (serializedObject) => {
  try {
    const token = await getToken();
    const res = await fetch(`${baseApiUrl}/Trip/AddHotelReviewApi`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${token?.access_token}`,
      },
      body: 'serializedObject=' + encodeURIComponent(serializedObject),
    });
    if (!res.ok) {
      return null;
    }
    return await res.json();
  } catch (error) {
    throw new Error('addHotelReviewApi failed');
  }
};
